import React, { useContext, useEffect, useState } from 'react';
import { ApplicationContext } from '../ApplicationContext';
import ieLogo from './commission-aviation-regulation.png';
import styles from './footer.module.scss';

const Footer = () => {
  const { caseDetails } = useContext(ApplicationContext);
  const [footerText, setFooterText] = useState(null);
  const [footerImage, setFooterImage] = useState(<div className={styles.image}></div>);

  const seFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Sverige AB ingår i den nordiska resekoncernen TUI Nordic, tillsammans med bland annat TUI Norge, TUI
          Danmark, TUI Finland, Nazar och flygbolaget TUIfly Nordic. TUI Nordic är en del av TUI Group.
        </p>
        <p>
          Adress: Söder Mälarstrand 27, Stockholm. Telefon kundservice: 0771-84 01 00. Organisationsnummer: 556211-6615.
        </p>
      </div>
    );
  };

  const noFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Norge AS er en del av TUI Nordic som er et nordisk reisekonsern, der også TUI Sverige, TUI Danmark, TUI
          Finland, Nazar og flyselskapet TUIfly Nordic inngår. TUI Nordic er en del av TUI Group.
        </p>
        <p>Adresse: Lille Grensen 7, 0159 Oslo. Telefon kundeservice: 67 11 50 00. Organisasjonsnummer: 931 393 936.</p>
      </div>
    );
  };

  const fiFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Finland Oy Ab on osa pohjoismaalaista matkailukonsernia TUI Nordicia, johon kuuluu myös TUI Sverige, TUI
          Norge, TUI Danmark, Nazar ja lentoyhtiö TUIfly Nordic. TUI Nordic on osa TUI Groupia
        </p>
        <p>
          Osoite: Konepajankuja 3, 00510 Helsinki. Asiakaspalvelun puhelinnumero 09 231 000 10 (pvm/mpm). Y-tunnus
          0709785-3.
        </p>
      </div>
    );
  };

  const dkFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Danmark indgår i den nordiske rejsekoncern TUI Nordic, hvor også TUI Sverige, TUI Norge og TUI Finland,
          Nazar og flyselskabet TUIfly Nordic indgår. TUI Nordic er en del af TUI Group.
        </p>
        <p>Adresse: Gammel Kongevej 60, Frederiksberg. Telefon kundeservice: 70 10 10 50. CVR-nr. 37425311.</p>
      </div>
    );
  };

  const ukFooterText = () => {
    return (
      <div className={styles.text}>
        <p>We're part of TUI Group - one of the world's leading travel companies.</p>
        <p>Registered address: Wigmore House, Wigmore Lane, Luton, Bedfordshire, United Kingdom, LU2 9TN</p>
      </div>
    );
  };

  const ieFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          We're part of TUI Group - one of the world's leading travel companies. And all of our holidays are designed to
          help you Discover Your Smile.
        </p>
        <p>Registered address: One Spencer Dock, North Wall Quay, Dublin 1, Ireland</p>
      </div>
    );
  };

  const nlFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Nederland N.V.
          <br />
          Volmerlaan 3<br />
          2288 GC Rijswijk
        </p>
        <p>
          Postbus 157
          <br />
          2280 AD Rijswijk
        </p>
      </div>
    );
  };

  const chFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          Die TUI Suisse Ltd ist eine hundertprozentige Tochtergesellschaft der TUI Group, des weltweit führenden
          Touristikkonzerns mit Sitz in Hannover (Deutschland).
        </p>
        <p>
          TUI Suisse Ltd
          <br />
          Friesenbergstrasse 75
          <br />
          Postfach 9180
          <br />
          CH - 8036 Zürich
        </p>
      </div>
    );
  };

  const atFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Austria Holding GmbH
          <br />
          Heiligenstädter Straße 31
          <br />A - 1190 Wien
        </p>
        <p>
          Firmenbuch-Nr.: FN 227414 h<br />
          Firmenbuchgericht: HG Wien
          <br />
          UID-Nr.: ATU 61025946
        </p>
      </div>
    );
  };

  const beFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Belgium NV
          <br />
          Gistelsesteenweg 1<br />
          8400 Oostende"
        </p>
      </div>
    );
  };

  const ppFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          TUI Poland sp. z o.o. jest częścią Grupy TUI AG.
          <br />
          Siedziba TUI Poland sp. z o.o.
          <br />
          ul. Wołoska 22a
          <br />
          02-675 Warszawa NIP 779-20-48-522
          <br />
          REGON 639522348
        </p>
      </div>
    );
  };

  const deFooterText = () => {
    return (
      <div className={styles.text}>
        <p>
          Die TUI Deutschland GmbH ist eine hundertprozentige Tochtergesellschaft der TUI Group, des weltweit führenden
          Touristikkonzerns mit Sitz in Hannover (Deutschland).
        </p>
        <p>
          TUI Deutschland GmbH, Karl-Wiechert-Allee 23, D-30625 Hannover
          <br />
          Sitz: Hannover, Handelsregister: Amtsgericht Hannover, HRB 62522
        </p>
      </div>
    );
  };

  const ieFooterImage = () => {
    return (
      <div className={`${styles.image} ${styles.ieImage}`}>
        <img src={ieLogo} alt="Commission aviation regulation" />
      </div>
    );
  };

  const ukFooterImage = () => {
    return (
      <div className={styles.image}>
        <div className={styles.abta}></div>
        <div className={styles.atol}></div>
      </div>
    );
  };

  useEffect(() => {
    if (!caseDetails) {
      return;
    }

    switch (caseDetails.sourceMarket) {
      case 'AT':
        setFooterText(atFooterText);
        break;
      case 'BE':
        setFooterText(beFooterText);
        break;
      case 'CH':
        setFooterText(chFooterText);
        break;
      case 'DE':
        setFooterText(deFooterText);
        break;
      case 'DK':
        setFooterText(dkFooterText);
        break;
      case 'FI':
        setFooterText(fiFooterText);
        break;
      case 'NL':
        setFooterText(nlFooterText);
        break;
      case 'NO':
        setFooterText(noFooterText);
        break;
      case 'PP':
        setFooterText(ppFooterText);
        break;
      case 'SE':
        setFooterText(seFooterText);
        break;
      case 'UK':
      default:
        if (caseDetails.currency === 'EUR') {
          setFooterText(ieFooterText);
          setFooterImage(ieFooterImage);
        } else {
          setFooterText(ukFooterText);
          setFooterImage(ukFooterImage);
        }
        break;
    }
  }, [caseDetails]);

  return (
    <footer className={`${styles.footer} tui-container`}>
      {footerText}
      {footerImage}
    </footer>
  );
};

export default Footer;
